import React from "react";

export default function EditIcon({
  color = "#707070",
  width = 13.5,
  height = 13.432,
  styles = {},
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={styles}
      viewBox="0 0 13.5 13.432">
      <g transform="translate(0 -0.261)">
        <path
          d="M12.46,46.293a.336.336,0,0,0-.336.336v2.985a1.01,1.01,0,0,1-1.009,1.009H1.681A1.01,1.01,0,0,1,.672,49.615V40.853a1.01,1.01,0,0,1,1.009-1.009H4.666a.336.336,0,0,0,0-.672H1.681A1.683,1.683,0,0,0,0,40.853v8.762A1.683,1.683,0,0,0,1.681,51.3h9.434A1.683,1.683,0,0,0,12.8,49.615V46.629A.336.336,0,0,0,12.46,46.293Zm0,0"
          transform="translate(0 -37.603)"
          fill={color}
        />
        <path
          d="M117.215.7a1.513,1.513,0,0,0-2.14,0l-6,6a.336.336,0,0,0-.086.148L108.2,9.7a.336.336,0,0,0,.414.414l2.848-.789a.336.336,0,0,0,.148-.086l6-6a1.515,1.515,0,0,0,0-2.14ZM109.81,6.921l4.909-4.909L116.3,3.595,111.393,8.5Zm-.316.635,1.265,1.265-1.75.485Zm7.641-4.793-.357.357-1.583-1.583.357-.357a.84.84,0,0,1,1.189,0l.395.395A.842.842,0,0,1,117.134,2.763Zm0,0"
          transform="translate(-104.552)"
          fill={color}
        />
      </g>
    </svg>
  );
}
